<template>
    <AdminPageInner v-if="user.id" :breadcrumbs="breadcrumbs">
        <template #heading>
            {{ user.name }}
        </template>
        <template v-if="user.id" #links>
            <div class="space-x-4">
                <router-link
                    v-if="isStudent"
                    :to="{name: 'admin.users.applications', params: {userId: user.id}}">
                    Application History
                </router-link>
                <router-link
                    v-if="isStudent && $can('viewAny', 'Award')"
                    :to="{name: 'admin.users.awards.index', params: {userId: user.id}}">
                    Awards
                </router-link>
                <router-link
                    v-if="user.user_can.update"
                    :to="{name: 'admin.users.edit', params: {userId: user.id}}">
                    Edit
                </router-link>
            </div>
        </template>

        <div v-if="user.id" class="row gutters-3 lg:flex-row-reverse mt-4">
            <div class="col-full lg:col-auto lg:min-w-96">
                <div class="flex justify-center items-center w-64 h-64 overflow-hidden mx-auto lg:mx-0 lg:w-full sm:rounded-lg lg:bg-white lg:shadow ">
                    <div class="w-56 h-56 rounded-full overflow-hidden bg-gray-300">
                        <ProfileImage :image="user.profile_image"/>
                    </div>
                </div>
            </div>
            <div class="col-full mt-6 space-y-6 lg:col lg:mt-0">
                <InfoCard>
                    <InfoCardItem title="Name" :content="user.name"/>
                    <InfoCardItem title="Email" :content="user.email"/>
                    <InfoCardItem title="Phone" :content="user.phone"/>
                    <InfoCardItem title="Credits" :content="user.credits"/>
                    <InfoCardItem title="Roles">
                        <ul>
                            <li v-for="role in user.roles">
                                {{ role.title }}
                            </li>
                        </ul>
                    </InfoCardItem>
                </InfoCard>
            </div>
        </div>
    </AdminPageInner>
</template>

<script>

import axios from "axios";
import AdminPageInner from "@/Components/Layout/AdminPageInner";
import {InfoCard, InfoCardItem} from "@/Components/InfoCard";
import Breadcrumbs from "@/Components/Breadcrumbs";
import ProfileImage from "@/Components/ProfileImage";
import {mapGetters} from "vuex";

export default {

    name: "UserShowPage",

    data() {
        return {
            user: {},
            form: this.$form(),
        }
    },

    provide() {
        return {
            form: this.form
        }
    },

    components: {
        AdminPageInner,
        InfoCard,
        InfoCardItem,
        Breadcrumbs,
        ProfileImage
    },

    methods: {
        setData(user) {
            this.user = user;
        },
    },

    computed: {
        isStudent() {
            return this.user.roles.reduce((check, role) => check || role.name === 'student', false);
        },
        breadcrumbs() {
            return [
                {label: 'Admin', to: {name: 'admin'}},
                {label: 'Users', to: {name: 'admin.users.index'}},
                {label: this.user.name || 'User', to: {name: this.$route.name, params: this.$route.params}},
            ];
        }
    },

    async beforeRouteEnter(to, from, next) {
        const data = (await axios.get(route('api.users.show', to.params.userId), {params: to.query})).data;
        next(vm => vm.setData(data));
    },

    async beforeRouteUpdate(to, from) {
        const data = (await axios.get(route('api.users.show', to.params.userId), {params: to.query})).data;
        this.setData(data);
    },
};
</script>
